module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp1_5012.377b707e.png";